<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :title="$t('SeaExport.PickingList')"
      width="1100px"
      :before-close="close"
      class="main-content"
    >
      <div style="text-align:left;flex:1;margin-bottom:10px">
        <el-button type="primary" size="mini" @click="pendingDialog.visible = true">{{ $t('SeaExport.Add3') }}</el-button>
        <el-button type="danger" size="mini" @click="remove">{{ $t('SeaExport.Remove') }}</el-button>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          config-module="90202"
          :row-data="rowData"
          min-height="400px"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div slot="footer">
        <div style="float:right;margin-bottom: 15px">
          <el-button type="primary" size="mini" @click="saveEvent">{{ $t('SeaExport.Save') }}</el-button>
          <el-button size="mini" @click="close">{{ $t('SeaExport.Close') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!--加入待拣货订单弹窗-->
    <el-dialog
      :visible.sync="pendingDialog.visible"
      :title="$t('SeaExport.PendingPickingOrder')"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div style="height: 700px;">
        <div style="height: 650px;overflow-y:auto; margin-bottom: 10px">
          <tab-pending ref="tabPending" :picking-order="pickingOrder" />
        </div>
        <div slot="footer">
          <div style="float:right;margin-bottom: 15px">
            <el-button type="primary" size="mini" @click="confirmWaitPicking">{{ $t('SeaExport.Confirm') }}</el-button>
            <el-button size="mini" @click="pendingDialog.visible = false">{{ $t('SeaExport.Cancel') }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import tabPending from '@/views/cargo/v0/AirExport/PreWarehouseOutbound/components/tabPending.vue'
import ColumnUtils from '@/utils/ColumnUtils'
import { stringToBool } from '@/utils/commonUtil'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { savePickingOrder } from '@/api/warehouseIn/warehouseIn'

export default {
  name: 'PickingOrderDialog',
  components: { tabPending },
  props: {
    openImperial: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: {},
      rowData: [],
      pendingDialog: {
        visible: false
      },
      innerVisible: false,
      pickingOrder: {}
    }
  },
  computed: {
    columnDefs() {
      const list = [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.JobNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 120
        }, {
          headerName: this.$t('SeaExport.BoardNumber'),
          field: 'palletNumber',
          colId: 'palletNumber',
          width: 140
        }, {
          headerName: this.$t('SeaExport.PickingStatus'),
          field: 'pickingStatus',
          colId: 'pickingStatus',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value === 1))
          }
        }, {
          headerName: this.$t('SeaExport.MasterBillNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Hbl2'),
          field: 'hbl',
          colId: 'hbl',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_Warehouse'),
          field: 'warehouseName',
          colId: 'warehouseName',
          width: 120
        }, {
          headerName: this.$t('SeaExport.DeliveryStation'),
          field: 'deliveryStation',
          colId: 'deliveryStation',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Flight'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_FlightDate'),
          field: 'voyageFlightDate',
          colId: 'voyageFlightDate',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          colId: 'quantity',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          colId: 'weight',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          colId: 'cubage',
          width: 120
        }
      ]
      if (this.openImperial) {
        list.push({
          headerName: this.$t('SeaExport.Weight') + 'LB',
          field: 'weightImperial',
          colId: 'weightImperial',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Cubage') + 'CFT',
          field: 'cubAgeImperial',
          colId: 'cubAgeImperial',
          width: 120
        })
      }
      return list
    }
  },
  methods: {
    async onShow(pickingOrder = {}, dataProvider = []) {
      const rowData = []
      for (const item of dataProvider) {
        rowData.push({ ...item })
      }
      this.pickingOrder = pickingOrder
      this.rowData = rowData
      this.innerVisible = true
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.PleaseCheckDataRemoved'))
        return
      }
      if (this.rowData.length === rows.length) {
        this.$message.warning(this.$t('SeaExport.KeepLeastOneDetail'))
        return
      }
      for (const row of rows) {
        const index = this.rowData.indexOf(row)
        this.rowData.splice(index, 1)
      }
    },
    // 获取新加入的待拣货数据
    async confirmWaitPicking() {
      const rows = await this.$refs.tabPending.getSelectRows() || []
      if (!rows || rows.length === 0) {
        return
      }
      for (const item of rows) {
        const detailList = this.rowData.filter(val => { return val.uuid === item.uuid })
        if (detailList.length === 0) {
          this.rowData.push({ ...item })
        }
      }
      this.pendingDialog.visible = false
    },
    // 变更拣货单
    async saveEvent() {
      const detailKeys = []
      this.rowData.forEach(item => { detailKeys.push(item.uuid) })
      this.loading = getLoading4Cxt()
      const payload = {
        detailKeys: detailKeys,
        branchId: this.$store.getters.currentOfficeId,
        pickingOrderKey: this.pickingOrder.pickingOrderKey
      }
      savePickingOrder(payload).then(res => {
        if (res.ok) {
          this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
          this.close()
          this.$emit('refresh')
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>
<style lang="scss">
  .change-charge-window {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
  }
</style>
